import CompanyService from '@/services/api/company.services'

const state = {
    projects: [],
    isLoading: false,
}

const mutations = {
    SET_PROJECTS(state, payload) {
        state.projects = payload || []
    },
    UPSERT_PROJECT(state, project) {
        if (!project) return
        const idx = state.projects.findIndex((p) => p.id === project.id)
        if (idx >= 0) state.projects.splice(idx, 1, project)
        else state.projects.push(project)
    },
    REMOVE_PROJECT(state, id) {
        state.projects = state.projects.filter((p) => p.id !== id)
    },
    SET_LOADING(state, payload) {
        state.isLoading = !!payload
    },
}

const unwrap = (response) => {
    const root = response && response.data ? response.data : {}
    return root.data !== undefined ? root.data : root
}

const actions = {
    getProjects({ commit }, params = {}) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            CompanyService.listProjects(params)
                .then((response) => {
                    const data = unwrap(response)
                    const list = Array.isArray(data) ? data : data?.data || []
                    commit('SET_PROJECTS', list)
                    commit('SET_LOADING', false)
                    return resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    return reject(error)
                })
        })
    },
    createProject({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CompanyService.createProject(payload)
                .then((response) => {
                    const data = unwrap(response)
                    const project = data?.project || data
                    if (project && project.id) commit('UPSERT_PROJECT', project)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    updateProject({ commit }, { id, payload }) {
        return new Promise((resolve, reject) => {
            CompanyService.updateProject(id, payload)
                .then((response) => {
                    const data = unwrap(response)
                    const project = data?.project || data
                    if (project && project.id) commit('UPSERT_PROJECT', project)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    deleteProject({ commit }, id) {
        return new Promise((resolve, reject) => {
            CompanyService.deleteProject(id)
                .then((response) => {
                    commit('REMOVE_PROJECT', id)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    projects: (state) => state.projects,
    isLoading: (state) => state.isLoading,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
